<template>
  <div>
    <v-dialog
      :value="showDialog"
      width="400"
      @input="handleInpugShowDialog"
    >
      <v-card>
        <v-card-title class="subheading py-0">
          <v-layout align-center>
            <div class="body-2">
              評價本次客服服務
            </div>
            <v-spacer />
            <v-btn
              icon
              @click="handleInpugShowDialog(false)"
            >
              <v-icon small>
                close
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout class="mx-0 mb-3 text-xs-center likeBtnWrap">
            <v-flex
              :class="{noActive:isLike && isLike!=='-1'}"
              @click="isLike = '-1';submit()"
            >
              <div>
                <img src="https://static.kkren.com.tw/static/images/comment/-1.png">
              </div>
              不滿意
            </v-flex>
            <v-flex
              :class="{noActive:isLike && isLike!=='1'}"
              @click="isLike = '1';submit()"
            >
              <div>
                <img src="https://static.kkren.com.tw/static/images/comment/1.png">
              </div>
              一般
            </v-flex>
            <v-flex
              :class="{noActive:isLike && isLike!=='2'}"
              @click="isLike = '2';submit()"
            >
              <div>
                <img src="https://static.kkren.com.tw/static/images/comment/2.png">
              </div>
              很好
            </v-flex>
          </v-layout>
        <!-- <v-btn
          :disabled="!isLike"
          block
          color="info"
          @click="submit"
        >提交</v-btn> -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <AppScoreDialog
      ref="AppScoreDialog"
    />
  </div>
</template>
<script>
import AppScoreDialog from './AppScoreDialog.vue'

export default {
  components: {
    AppScoreDialog,
  },
  props: {
    showDialog: Boolean,
    propModel: Object,
  },
  data () {
    return {
      isLike: '',
    }
  },
  watch: {
    showDialog () {
      this.isLike = ''
    },
  },
  methods: {
    handleInpugShowDialog (v) {
      this.$emit('update:showDialog', v)
    },
    async submit () {
      try {
        this.loading = true
        const res = await this.$store.dispatch('comment/updateLike', {
          cid: this.propModel.cid,
          isLike: this.isLike,
        })
        if (!res.data.error) {
          this.propModel.isLike = this.isLike
          this.handleInpugShowDialog(false)
          this.$emit('liked')

          if (this.isLike === '2' && !localStorage.AppScoreDialogShowed && this.$store.state.project === 'pc') {
            this.$refs.AppScoreDialog.open()
            localStorage.AppScoreDialogShowed = '1'
          }
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
.likeBtnWrap {
  > * {
    cursor: pointer;
  }
  .noActive {
    opacity: 0.5;
  }
}
</style>
